export const replaceObjectById = <T extends { id: string }>(
  array: T[],
  id: string,
  replacement: T
): T[] => {
  const foundIndex = array.findIndex((item) => item.id === id);

  if (foundIndex !== -1) {
    return array.map((item, index) =>
      index === foundIndex ? replacement : item
    );
  } else {
    return [...array, replacement];
  }
};
